var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWtLogoAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 50,
    viewBox: "0 0 158 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_9962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4292 4.37207H44.8858V23.0241H41.4292V4.37207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6357 23.7751H40.6797V3.62109H45.6357V23.7751ZM42.1791 22.2731H44.1394V5.1231H42.1791V22.2731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6807 4.37207H57.4312C58.6295 4.37207 59.3731 4.58444 59.8247 6.18495L61.023 10.4755L59.8247 14.9262C59.6926 15.434 59.5052 15.9388 58.9736 16.3635L60.7557 23.0241H57.0041L55.6492 16.816H52.1373V23.0241H48.6807V4.37207ZM56.448 13.6181C56.6078 13.5103 56.7676 13.1933 56.8474 12.8732L57.4066 10.4755L56.8474 8.07785C56.7676 7.70542 56.6078 7.41302 56.448 7.3053H52.1403V13.6211H56.448V13.6181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7329 23.7751H56.4021L55.0471 17.567H52.8871V23.7751H47.9312V3.62109H57.4314C58.9431 3.62109 59.9908 4.01506 60.5469 5.97876L61.8005 10.4694L60.55 15.117C60.4271 15.5879 60.2397 16.1173 59.8126 16.5944L61.7329 23.772V23.7751ZM57.6096 22.2731H59.7819L58.1258 16.0835L58.5099 15.7757C58.8509 15.5048 58.9861 15.1878 59.1029 14.7323L60.2458 10.4756L59.1059 6.38504C58.7618 5.16927 58.3685 5.1231 57.4345 5.1231H49.4336V22.2731H51.3939V16.065H56.2577L57.6127 22.2731H57.6096ZM56.6756 14.3691H51.3908V6.55124H56.6756L56.863 6.67744C57.3362 6.99446 57.5205 7.65005 57.5789 7.91783L58.175 10.4725L57.5758 13.0425C57.5082 13.3103 57.3116 13.9413 56.863 14.2429L56.6756 14.3691ZM52.8902 12.8671H56.0641C56.0856 12.8147 56.1041 12.7563 56.1194 12.6886L56.6356 10.4725L56.1164 8.24408C56.101 8.16714 56.0795 8.1025 56.0611 8.05018H52.8871V12.864L52.8902 12.8671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.342 7.46227H63.5796L64.191 4.37207H76.0018L76.6133 7.46227H71.7986V23.0241H68.342V7.46227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5482 23.7751H67.5923V8.2133H62.667L63.5765 3.62109H76.6163L77.5257 8.2133H72.5482V23.7751ZM69.0916 22.2731H71.0519V6.7113H75.7037L75.3903 5.12003H64.8116L64.4982 6.7113H69.0978V22.2731H69.0916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3294 21.1038C81.142 20.5714 80.718 19.2109 80.3462 17.6935V4.34473H83.8028V17.1888C83.9103 17.7736 84.1469 18.5738 84.3097 19.0817C84.4419 19.5095 84.6016 19.8819 84.7614 19.9342H88.513C88.6727 19.8819 88.8325 19.5095 88.9646 19.0817C89.1244 18.5769 89.3641 17.7766 89.4716 17.1888V4.34473H92.9282V17.6935C92.5564 19.2109 92.1293 20.5714 91.945 21.1038C91.4657 22.4889 90.7467 22.9967 89.4439 22.9967H83.8304C82.5277 22.9967 81.8087 22.4889 81.3294 21.1038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4407 23.7476H83.8272C82.1834 23.7476 81.1941 23.0089 80.6195 21.353C80.4444 20.8482 80.0081 19.4755 79.6148 17.875L79.5933 17.7857V3.59668H84.5492V17.1178C84.6291 17.5334 84.792 18.1305 85.0193 18.8538C85.0654 18.9984 85.1023 19.1062 85.133 19.1831H88.1287C88.1595 19.1062 88.1963 19.0015 88.2424 18.8569C88.4698 18.1336 88.6326 17.5334 88.7125 17.1178V3.59668H93.6685V17.7857L93.647 17.875C93.2537 19.4786 92.8174 20.8513 92.6423 21.3561C92.0708 23.012 91.0814 23.7507 89.4346 23.7507L89.4407 23.7476ZM81.0927 17.6042C81.4399 19.0046 81.8454 20.3127 82.0359 20.8575C82.4446 22.0394 82.9392 22.2456 83.8272 22.2456H89.4407C90.3318 22.2456 90.8264 22.0394 91.232 20.8575C91.4225 20.3096 91.8281 19.0046 92.1753 17.6011V5.09561H90.215V17.2564L90.2027 17.3241C90.0921 17.9304 89.8555 18.7368 89.6742 19.3093C89.4592 19.9957 89.2195 20.4881 88.7432 20.6482L88.6296 20.6851H84.6353L84.5216 20.6482C84.0454 20.4912 83.8057 19.9988 83.5906 19.3062C83.3295 18.4752 83.1513 17.8073 83.0621 17.3241L83.0499 17.1917V5.09561H81.0896V17.6042H81.0927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4539 23.0246L99.949 4.37256H106.226L110.721 23.0246H106.89L105.851 18.3092H100.318L99.2792 23.0246H95.4478H95.4539ZM105.163 15.1636L103.461 7.30271H102.717L101.015 15.1636H105.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.674 23.7755H106.291L105.252 19.0601H100.923L99.8845 23.7755H94.5015L99.3591 3.62451H106.816L111.674 23.7755ZM107.495 22.2734H109.772L105.639 5.12344H100.542L96.4095 22.2734H98.6862L99.7248 17.5581H106.46L107.498 22.2734H107.495ZM106.094 15.9145H100.087L102.115 6.55466H104.066L106.094 15.9145ZM101.946 14.4125H104.238L103.092 9.12162L101.946 14.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65 23.0241H113.357V4.37207H116.814V19.9339H124.393L123.65 23.0241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24 23.7751H112.607V3.62109H117.563V19.1829H125.346L124.24 23.7751ZM114.107 22.2731H123.06L123.444 20.6818H116.067V5.1231H114.107V22.2731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.381 20.0662L139.797 23.0241H136.604L130.515 10.7679V23.0241H127.058V7.32992L127.642 4.37207H130.994L136.924 16.6559V4.37207H140.381V20.0662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.411 23.7751H136.14L131.261 13.9597V23.7751H126.305L126.321 7.18529L127.024 3.62417H131.461L136.174 13.3842V3.62109H141.13L141.115 20.2109L140.411 23.772V23.7751ZM137.068 22.2731H139.182L139.634 19.9924V5.1231H137.674V19.9308L130.524 5.1231H128.256L127.805 7.40382V22.2731H129.765V7.57618L137.068 22.2731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.372 4.37207H155.463L156.502 7.81007L153.205 8.58262L152.778 7.3053H147.831V11.996H152.299L152.858 13.5934L152.299 15.1662H147.831V19.8816H152.274L152.646 18.7889L156.078 19.5892L155.039 23.0272H144.375V4.37207H144.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.596 23.7751H143.625V3.62109H156.023L157.451 8.35797L152.71 9.46908L152.24 8.05325H148.581V11.2419H152.83L153.651 13.5935L152.827 15.9142H148.581V19.1306H151.736L152.154 17.9025L157.024 19.0382L155.596 23.7751ZM145.121 22.2731H154.483L155.129 20.1371L153.138 19.6723L152.812 20.6295H147.085V14.4122H151.773L152.065 13.5873L151.77 12.7409H147.085V6.55124H153.322L153.703 7.69314L155.559 7.25916L154.913 5.12003H145.127V22.27L145.121 22.2731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0051 3.73828H31.7232C30.2207 3.73828 28.7705 4.29538 27.6552 5.30185L23.1201 9.38313C23.1201 9.38313 27.0099 9.59858 27.2035 12.5995C16.6033 14.6802 33.4561 18.4106 33.4561 18.4106L39.0051 3.73828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44727 3.73828H12.1822C13.8199 3.73828 15.393 4.38156 16.5514 5.54192C17.6452 6.63765 19.5409 8.36743 22.8255 11.076C13.2884 14.5017 17.6237 20.562 18.0538 23.5076C15.264 23.6245 12.9289 23.5076 12.9289 23.5076L5.44727 3.73828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1345 23.5569H31.3947C31.3947 23.5569 13.7338 16.8809 23.7871 11.7686C13.3589 15.9145 26.1345 23.5569 26.1345 23.5569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8352 12.7471H12.0962V14.4892H13.8352V12.7471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37626 12.7471H1.63721V14.4892H3.37626V12.7471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.021 11.584H13.835V12.772H15.021V11.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 13.7754H8.85449V14.9635H10.0405V13.7754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3664 16.1421H9.32764V19.1861H12.3664V16.1421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18961 16.1421H6.15088V19.1861H9.18961V16.1421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0963 7.22852H6.55957V12.7749H12.0963V7.22852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6972 3.62109H12.0962V7.22838H15.6972V3.62109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15085 2.99658H3.9292V7.2256H8.15085V2.99658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97848 5.95752H2.79248V7.14559H3.97848V5.95752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63717 0.0078125H0.451172V1.19588H1.63717V0.0078125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04 3.77832H4.854V4.96639H6.04V3.77832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57125 11.584H3.38525V12.772H4.57125V11.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9594 0.602051H11.7734V1.79012H12.9594V0.602051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63326 13.895H5.44727V15.0831H6.63326V13.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28797 10.002H6.55957V12.7351H9.28797V10.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4533 18.4075C33.4533 18.4075 48.6807 23.0213 61.7328 23.7723C67.4108 24.0985 63.6716 32.2211 68.6736 37.395C73.6757 42.569 61.5976 26.8348 61.5976 26.8348L57.7938 27.2103L36.1817 28.9031L33.4502 18.4014L33.4533 18.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8301 32.6952H47.0708L47.6822 29.605H59.493L60.1045 32.6952H55.2898V48.257H51.8332V32.6952H51.8301Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0395 49.008H51.0835V33.4462H46.1582L47.0677 28.854H60.1075L61.0169 33.4462H56.0395V49.008ZM52.5829 47.506H54.5431V31.9442H59.1949L58.8815 30.3529H48.3028L47.9894 31.9442H52.5859V47.506H52.5829Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8345 29.605H72.585C73.7833 29.605 74.5269 29.8174 74.9785 31.4179L76.1768 35.7084L74.9785 40.1591C74.8464 40.6638 74.659 41.1717 74.1274 41.5964L75.9095 48.257H72.158L70.803 42.0489H67.2911V48.257H63.8345V29.605ZM71.6018 38.851C71.7616 38.7432 71.9214 38.4231 72.0013 38.1061L72.5605 35.7084L72.0013 33.3108C71.9214 32.9383 71.7616 32.6459 71.6018 32.5382H67.2941V38.854H71.6018V38.851Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8868 49.008H71.5559L70.2009 42.7999H68.0409V49.008H63.085V28.854H72.5852C74.0539 28.854 75.1446 29.2541 75.7008 31.2117L76.9543 35.7023L75.7038 40.3499C75.5809 40.8208 75.3935 41.3502 74.9664 41.8273L76.8868 49.0049V49.008ZM72.7634 47.506H74.9357L73.2796 41.3164L73.6606 41.0086C74.0016 40.7347 74.1368 40.4207 74.2567 39.9652L75.3996 35.7115L74.2597 31.621C73.9156 30.4053 73.5223 30.3591 72.5883 30.3591H64.5874V47.5091H66.5477V41.301H71.4115L72.7665 47.5091L72.7634 47.506ZM71.8294 39.602H66.5446V31.7872H71.8294L72.0168 31.9134C72.49 32.2304 72.6743 32.886 72.7327 33.1538L73.3288 35.7085L72.7296 38.2785C72.662 38.5463 72.4654 39.1803 72.0168 39.4789L71.8294 39.6051V39.602ZM68.0409 38.1H71.2149C71.2364 38.0477 71.2548 37.9892 71.2702 37.9215L71.7864 35.7054L71.2671 33.477C71.2517 33.4 71.2302 33.3354 71.2118 33.2831H68.0379V38.0969L68.0409 38.1Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9451 48.257L83.4402 29.605H89.7174L94.2125 48.257H90.3811L89.3425 43.5417H83.8089L82.7704 48.257H78.939H78.9451ZM88.6543 40.3961L86.9521 32.5351H86.2086L84.5064 40.3961H88.6543Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1621 49.0079H89.779L88.7405 44.2925H84.4113L83.3728 49.0079H77.9897L82.8474 28.8569H90.3044L95.1621 49.0079ZM90.9835 47.5059H93.2602L89.1277 30.3559H84.0303L79.8978 47.5059H82.1745L83.213 42.7905H89.948L90.9865 47.5059H90.9835ZM89.5824 41.1469H83.5756L85.6035 31.7871H87.5545L89.5824 41.1469ZM85.4345 39.6449H87.7266L86.5805 34.354L85.4345 39.6449Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0177 44.8187L100.45 44.0184L100.821 45.1111H105.105C105.317 44.9233 105.504 44.4986 105.636 43.9907L105.98 42.6334L105.848 42.1009C105.741 41.6762 105.608 41.4084 105.421 41.276L98.8766 38.4782C98.1853 38.1858 97.8135 37.758 97.5738 36.9608L96.9102 34.7509L98.1607 31.1282C98.5325 30.0633 99.1193 29.6108 100.13 29.6108H107.925L108.964 33.0488L105.664 33.8214L105.24 32.541H101.304C101.12 32.6487 101.012 32.8334 100.88 33.2858L100.456 34.7509L100.563 35.071C100.751 35.6558 100.855 35.8713 101.015 35.9759L107.32 38.666C108.011 38.9584 108.411 39.4108 108.65 40.1588L109.449 42.6365L108.331 46.2868C107.959 47.5395 107.108 48.2598 106.017 48.2598H98.0654L97.0269 44.8218L97.0177 44.8187Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.008 49.0078H97.5L96.0713 44.271L100.941 43.1352L101.359 44.3602H104.72C104.776 44.2402 104.846 44.0586 104.914 43.8L105.212 42.6304L105.126 42.2796C105.071 42.0641 105.025 41.9533 104.997 41.9041L98.5908 39.1647C97.6844 38.78 97.1682 38.186 96.864 37.1703L96.1297 34.7264L97.4601 30.8729C97.9363 29.5094 98.812 28.8477 100.136 28.8477H108.484L109.913 33.5845L105.172 34.6956L104.702 33.2798H101.666C101.648 33.3291 101.626 33.3968 101.599 33.486L101.239 34.7264L101.27 34.8249C101.365 35.1266 101.424 35.2712 101.457 35.342L107.609 37.9674C108.494 38.3429 109.05 38.9647 109.357 39.9219L110.226 42.6243L109.04 46.4994C108.576 48.0629 107.443 49.0017 106.011 49.0017L106.008 49.0078ZM98.6123 47.5058H106.008C107.025 47.5058 107.443 46.6071 107.602 46.0715L108.653 42.6428L107.928 40.3897C107.753 39.845 107.507 39.5649 107.019 39.3586L100.591 36.6009C100.195 36.3362 100.032 35.8929 99.8413 35.2989L99.6631 34.7664L100.155 33.0767C100.287 32.6242 100.456 32.1595 100.926 31.8886L101.098 31.7901H105.774L106.155 32.932L108.011 32.498L107.366 30.3589H100.127C99.5248 30.3589 99.1653 30.5159 98.8673 31.3746L97.6967 34.7664L98.2927 36.7455C98.4679 37.3303 98.6799 37.5827 99.1715 37.7889L105.86 40.6668C106.297 40.9776 106.472 41.5009 106.576 41.9195L106.754 42.6366L106.361 44.1786C106.174 44.8927 105.916 45.3975 105.596 45.6776L105.384 45.8622H100.284L99.958 44.905L97.964 45.3698L98.6092 47.5058H98.6123Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.962 29.605H115.714L118.319 38.2662H119.674L122.28 29.605H126.056L121.933 41.5164H120.734V48.257H117.278V41.5164H116.079L111.956 29.605H111.962Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.49 49.0079H116.534V42.2673H115.554L110.912 28.8569H116.27L118.876 37.5181H119.118L121.724 28.8569H127.11L122.467 42.2673H121.487V49.0079H121.49ZM118.034 47.5059H119.994V40.7653H121.407L125.011 30.3559H122.845L120.24 39.017H117.769L115.164 30.3559H113.022L116.627 40.7653H118.04V47.5059H118.034Z",
    fill: "#E73924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.594 3.80078C38.594 3.80078 36.0022 7.60416 35.9494 7.70191C33.5913 12.0705 34.2283 17.038 34.2283 17.038L38.2121 11.4752L38.2598 10.5153L38.3188 9.32853L38.594 3.80078Z",
    fill: "url(#paint0_linear_57_9962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9043 3.80078C5.9043 3.80078 8.81394 7.02394 8.86796 7.10414C12.4007 12.3136 11.8241 20.7675 11.8241 20.7675L6.30506 11.8649L5.9043 3.80078Z",
    fill: "url(#paint1_linear_57_9962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9251 3.80078H31.4991C30.0355 3.80078 28.6234 4.3409 27.5354 5.31712L23.1182 9.27715C23.1182 9.27715 26.9085 9.48768 27.0944 12.3963C16.7687 14.4152 32.8082 19.0231 32.8082 19.0231C32.8082 19.0231 32.7454 11.0629 35.7982 7.59539C35.8711 7.51268 36.003 7.60416 35.9515 7.70191C33.5934 12.0705 34.2303 17.038 34.2303 17.038L38.2142 11.4752L38.2619 10.5153L38.3209 9.32853L38.5948 3.80078H35.9251Z",
    fill: "url(#paint2_linear_57_9962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8358 10.9162C19.6485 8.30088 17.8042 6.62539 16.7376 5.5627C15.6031 4.43484 14.0679 3.80074 12.4661 3.80074H9.98107C9.98107 3.80074 13.142 5.83714 12.7098 6.42989C9.80518 3.35586 5.9043 3.80074 5.9043 3.80074L6.30506 11.8649L11.8241 20.7687C11.8241 20.7687 12.3995 12.3148 8.86796 7.10535C8.81269 7.02515 8.92827 6.93868 8.98983 7.01387C13.3091 12.2283 13.1935 22.9768 13.1935 22.9768C13.1935 22.9768 15.4674 23.0908 18.1861 22.9768C17.7678 20.1195 13.5453 14.2409 22.8345 10.9175L22.8358 10.9162Z",
    fill: "url(#paint3_linear_57_9962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7689 11.5903C13.6115 15.6118 26.0566 23.0268 26.0566 23.0268H31.1812C31.1812 23.0268 13.9771 16.5504 23.7689 11.5903Z",
    fill: "url(#paint4_linear_57_9962)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_9962",
    x1: 60.4226,
    y1: 10.42,
    x2: 64.8662,
    y2: 10.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E94E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E13B8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_9962",
    x1: -22.3429,
    y1: 43.6905,
    x2: -13.3315,
    y2: 34.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E94E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C44527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9F3D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#7F363E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#643047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4E2B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#3D2755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#312459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2A235B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29235C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_9962",
    x1: 22.7425,
    y1: 6.46252,
    x2: 37.148,
    y2: 12.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#EF7943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D71524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D31424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#CA1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B9142A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A2132F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#841335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E1337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_57_9962",
    x1: 23.7956,
    y1: 9.26833,
    x2: 7.83154,
    y2: 14.8938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#EF7943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D71524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CE1425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B7142A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#921332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E1337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_57_9962",
    x1: 20.6771,
    y1: 12.9763,
    x2: 27.7107,
    y2: 21.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#EF7943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D71524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BE1429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7E1336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E1337"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_9962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 49,
    fill: "white",
    transform: "translate(0.451172 0.0078125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtLogoAlt);
export default __webpack_public_path__ + "static/media/wt_logo_alt.809029bc12d590c3a5b572cd920844c6.svg";
export { ForwardRef as ReactComponent };